import { Delegate } from "vendor";
import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";

/** Match grid columns to rendered chips (`--number-of-options` SSR can diverge per product/catalog shape). */
function syncQuickBuyGridColumnCount(grid) {
  const radioCount = grid.querySelectorAll(':scope > input.sr-only[type="radio"]').length;
  const bisCount = grid.querySelectorAll(":scope > button.block-swatch.klaviyo-bis-button").length;
  const n = radioCount + bisCount;
  if (n >= 1) {
    grid.style.setProperty("--number-of-options", String(n));
  }
}

let _delegate,
	_ProductQuickBuyGHD_instances,
	onOptionClicked_fn,
	form_get;

var ProductQuickBuyGHD = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this,_ProductQuickBuyGHD_instances);
    __privateAdd(this, _delegate, new Delegate(this));
  }
  connectedCallback() {
      __privateGet(this, _delegate).off().on("click", '.block-swatch:not(.is-disabled)', __privateMethod(this, _ProductQuickBuyGHD_instances, onOptionClicked_fn).bind(this));
      queueMicrotask(() => syncQuickBuyGridColumnCount(this));
  }
  disconnectedCallback() {
      __privateGet(this, _delegate).off();
  }
};

_ProductQuickBuyGHD_instances = new WeakSet();
form_get = function() {
  return this.querySelector("form");
};
_delegate = new WeakMap();

onOptionClicked_fn = async function(event, target) {
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  
  const formData = new FormData(__privateGet(this, _ProductQuickBuyGHD_instances, form_get));
  formData.set("id", Number(target.previousSibling.getAttribute("data-variant-id")));
  formData.set("sections", sectionsToBundle.join(","));
  formData.set("sections_url", `${Shopify.routes.root}variants/${target.previousSibling.getAttribute("data-variant-id")}`);

  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
      // Needed for Shopify to check inventory
    }
  });
  
  const responseJson = await response.json();
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  if (response.ok) {
    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
      return window.location.href = `${Shopify.routes.root}cart`;
    }
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    __privateGet(this, _ProductQuickBuyGHD_instances, form_get).dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
        cart: cartContent,
        onSuccessDo: formData.get("on_success")
      }
    }));
	document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        onSuccessDo: formData.get("on_success"),
        cart: cartContent
      }
    }));
    target.previousSibling.dispatchEvent(new CustomEvent("listbox:select", {
      bubbles: true,
      detail: {
        value: target.previousSibling.value
      }
    }));
  } else {
	  document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
};
if (!window.customElements.get("product-quick-buy-ghd")) {
  window.customElements.define("product-quick-buy-ghd", ProductQuickBuyGHD);
}

export {
	ProductQuickBuyGHD
};

